/**
 * Created by Jie Gao on 24/09/18.
 */
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {BonusBunniesGameMode} from "../gamemode/BonusBunniesGameMode";
import {RespinZeroBetController} from "@nolimitcity/slot-game/bin/game/zerobet/RespinZeroBetController";
import {ZeroBetController} from "@nolimitcity/slot-game/bin/core/zerobet/ZeroBetController";

export class BonusGameZeroBet extends ZeroBetController {
    private _nextMode:string;

    constructor() {
        super();
    }

    protected calculateIsTriggered(data:ParsedServerData):boolean {
        //console.log("mode: " + data.mode);
        //console.log("nextMode: " + data.nextMode);
        this._nextMode = data.nextMode;
        return (data.nextMode == BonusBunniesGameMode.BONUS_GAME);
    }

    protected getZeroBetNumberLeft(data: ParsedServerData): number{
        return data.freespinsLeft;
    }

    public shouldSubtractZeroBetCounter():boolean {
        return true;
    }

    public shouldShowZeroBetCounter():boolean {
        return (this._nextMode == BonusBunniesGameMode.BONUS_GAME);
    }
}
